module.exports = __webpack_public_path__ + "static/media/b1.cb0f46a4.jpg";